<div *ngIf="amountCompanies > 1" class="strong mb-3">
  {{ company.regularName }}
</div>

<table class="facturation-overview-table">
  <tr class="header-row">
    <th class="id">Jobnr</th>
    <th class="date">Aanvraag</th>
    <th class="description">Omschrijving</th>
    <th class="price">Prijs</th>
  </tr>

  <tr>
    <td class="id secondary-color">
      <span>{{ project?.id | or }}</span>
    </td>
    <td class="date">
      <span>{{ adjustment.currentCreatedAt | date: 'dd.MM.yyyy' }}</span>
    </td>
    <td class="description">
      <div *ngIf="subProjectDescription?.length > 0" class="secondary-color">
        {{ subProjectDescription }}
      </div>
      <div *ngIf="adjustment.projectPlacement?.address != null" class="address">
        {{
          adjustment.projectPlacement.address.line1
            | printAddress
              : adjustment.projectPlacement.address.postalCode
              : adjustment.projectPlacement.address.city
        }}
      </div>
    </td>
    <td class="price">
      <ng-container
        *ngIf="
          !adjustmentInvoice?.onlyChargePriceLines &&
          stickerProductionPrice != null &&
          stickerProductionPrice > 0
        "
      >
        {{ stickerProductionPrice | asFormatDecimal: true:2 }} €
      </ng-container>
    </td>
  </tr>

  <ng-container *ngIf="toShowPriceLines?.length > 0">
    <tr *ngFor="let priceLine of toShowPriceLines">
      <td class="id"></td>
      <td class="date"></td>
      <td class="description">{{ priceLine.text }}</td>
      <td class="price">{{ priceLine.price | asFormatDecimal: true:2 }} €</td>
    </tr>
  </ng-container>
</table>
